import { type ActionItem } from 'shared/ui'
import { type TableStore } from 'shared/ui/TableNew/store/tableStore'
import { type RowUser } from 'entities/Users/model/Table/RowUser'
import { EnumUserRoles } from 'entities/Users/model/types'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { userProfile } from './userProfile/userProfile'
import { logoutAllDevices } from './logoutAllDevices/logoutAllDevices'
import { deleteMember } from './deleteMember/deleteMember'

type IndividualActionParams = {
  loadData: () => Promise<void>
  fetchCounts: () => Promise<void>
  tableStore: TableStore<RowUser>
}

export const getMembersActions = (
  member: RowUser,
  entities: IEntitiesStore,
  params: IndividualActionParams
): ActionItem[] => {
  const { loadData, fetchCounts, tableStore } = params
  const isOwnerOrCurrentUser =
    member.role === EnumUserRoles.OWNER || member.id === entities.usersStore.user?.id

  const onIndividualActionSuccess = () => {
    tableStore.bulkStore.onRowSelect(member, false)
  }

  const actions = [userProfile(member), logoutAllDevices([member])]

  if (!isOwnerOrCurrentUser) {
    actions.push(
      deleteMember(member, entities, () => {
        onIndividualActionSuccess()
        fetchCounts()
        loadData()
      })
    )
  }

  return actions
}
